import { Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import LootieImage from '../../Assets/Images/dashboardGif.gif'
import { PAGES_ROUTES } from '../../Constants'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { RoleConfirmationModal } from '../../Models'
import mainApiService from '../../Services'
import { showAlert } from '../../Store/Slice/alert.slice'
import RoleConfirmation from '../Dialogs/RoleConfirmation'
import MyDashboardIcon from '../Icons/MyDashboardIcon'
import DashboardCard from '../Shared/DashboardCard'

/**
 * Dashboard Component
 * @component
 * @returns {React.JSX.Element | null} JSX Element representing the AssetCloneVersion component.
 */

const MyDashboard = () => {
  const [pinSearchData, setPinSearchData] = useState([])
  const getPinnedSearch = async () => {
    let requestedData: any = API_CONFIG(API_LIST.PINNED_SEARCH.COUNT)
    if (localStorage.getItem('isRecentPinAction') === 'yes') {
      requestedData = API_CONFIG(API_LIST.PINNED_SEARCH.COUNT, null, null, null, {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      })
    }

    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      localStorage.setItem('isRecentPinAction', 'no')
      if (result?.data) {
        setPinSearchData(result?.data)
      } else {
        setPinSearchData([])
      }
    }
  }
  useEffect(() => {
    getPinnedSearch()
  }, [])
  const [dialogProps, setDialogProps] = useState<RoleConfirmationModal>({
    heading: '',
    description: '',
    color: 'primary',
    open: false,
  })
  const [selectedPinnedId, setSelectedPinnedId] = useState('')
  const handleClose = () => {
    setDialogProps({
      heading: '',
      description: '',
      color: 'primary',
      open: false,
    })
    setSelectedPinnedId('')
  }
  const handleUnpinClick = async () => {
    const requestedData = API_CONFIG(
      API_LIST.ADVANCED_SEARCH.DELETE_PINNED_SEARCH,
      {},
      { searchId: selectedPinnedId as any },
      {
        isPinnedToDashboard: 'true',
      },
    )
    const result = await mainApiService(requestedData)
    if (result.message) {
      handleClose()
      showAlert([true, result?.message, 'success'])
      localStorage.setItem('isRecentPinAction', 'yes')
      getPinnedSearch()
    } else {
      showAlert([true, result?.error?.message, 'error'])
    }
  }
  const openDialog = (name: string, id: any) => {
    setSelectedPinnedId(id)
    setDialogProps({
      heading: 'Unpin Widget',
      description: (
        <div>
          <p>Are you sure you want to unpin {name} widget?</p>
        </div>
      ),
      color: 'warning',
      Icon: 'DeleteRoleWarIcon',
      open: true,
      iconColor: 'warning',
      cancelButtonLabel: 'Close',
      successButtonLabel: 'Unpin',
      handleClose: handleClose,
    })
  }

  return pinSearchData.length ? (
    <div className='card-wrapper'>
      <h3 className='dashboard-header pb-1'>
        <MyDashboardIcon />
        My Dashboard
      </h3>
      <Grid container spacing={2} className='mb-1 mt-0'>
        {pinSearchData.map((item: any, index: number) => (
          <DashboardCard
            key={item.id}
            label={item.name}
            count={item.count[0]}
            colorClass={`color${index}`}
            onUnpin={() => openDialog(item.label, item.id)}
            link={{
              pathname: `/home/asset-state-details/${PAGES_ROUTES.AdvancedSearch}`,
              search: `?search=&filter=1&,id=${item.id}&,name=${item.name}`,
            }}
          />
        ))}
      </Grid>
      <RoleConfirmation
        handleSuccess={handleUnpinClick}
        {...dialogProps}
        handleClose={handleClose}
      />
    </div>
  ) : (
    <div className='dashboard-wrapper'>
      <h3>
        <MyDashboardIcon />
        My Dashboard
      </h3>
      <div className='d-flex justify-content-between align-items-center'>
        <img alt='' className='ml-auto mr-auto' src={LootieImage} height={238} />
      </div>
      <div className='lootie-text text-center'>Personalize your dashboard</div>
    </div>
  )
}

export default MyDashboard
